const ACTIONS = {
  NEW_BOOKS: "new-books",
  JAVASCRIPT_BOOKS: "javascript-books",
  PYTHON_BOOKS: "python-books",
  NEXT_SLIDER_NEW: "next-slider",
  BACK_SLIDER_NEW: "back-slider",
  CART_ITEMS_NUMBER: "cart-items-number",
  FAVORITE_ITEMS_NUMBER: "favorite-items-number",
  FAVORITE_BOOKS: "favorite-books",
  CART_INCLUDES_BOOKS: "shop-books",
  ORDER_BOOKS: "order-books",
};

export default ACTIONS;
